import { GlobalState } from 'ha/types/store';

import { MobileMenuType } from './types';

export const getIsShowingAuthModal = (state: GlobalState) =>
  state.navBar.isShowingAuthModal;

export const getIsMobileDrawerOpen = (state: GlobalState) =>
  state.navBar.currentMenu !== undefined;

export const getMobileMenuType = (state: GlobalState) =>
  state.navBar.currentMenu || MobileMenuType.main;
